import { render } from "./NotificationsList.vue?vue&type=template&id=50feed66&scoped=true"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"

import "./NotificationsList.vue?vue&type=style&index=0&id=50feed66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50feed66"],['__file',"src/layouts/navbar/NotificationsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50feed66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50feed66', __exports__)) {
    api.reload('50feed66', __exports__)
  }
  
  module.hot.accept("./NotificationsList.vue?vue&type=template&id=50feed66&scoped=true", () => {
    api.rerender('50feed66', render)
  })

}


export default __exports__